import { get } from 'lodash'
import moment from 'moment'
import { type } from './dataType'

const prepareShow = access => {
  access.go_in = moment(access.go_in, 'YYYYMMDD').format('DD/MM/YYYY')
  if (access.go_out !== null) {
    access.go_out = moment(access.go_out, 'YYYYMMDD').format('DD/MM/YYYY')
  }
  access.visitor._type = get(type, access.visitor.type, access.visitor.type)
  return access
}

const prepareSearch = (search) => {
  search.generic = search.generic
  return search
}

export default {
  prepareShow,
  prepareSearch,
  doFilterSearch () {
    this.setPage(1)
  },
  doClearSearch () {
    this.search.generic = null
    this.doLoadAll()
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/access/index/resources/methods.js